<template>
  <div id="contenedor-agregar-nueva-adjudicacion">
    <custom-button
      v-if="mixValidaScopesActions(1)"
      :onlyIcon="onlyIcon"
      @click="mostrarDialogo = true"
      :label="onlyIcon ? '' : 'Nuevo'"
      iconText="mdi-plus"
      tipo="agregar">
    </custom-button>
    <v-dialog
      v-model="mostrarDialogo"
      width="80%">
      <v-form
        v-model="formularioValido"
        ref="agregarNuevaAdjudicacion">
        <v-card>
          <v-card-title class="secondary--text">
            Agregar Nueva Adjudicacion Directa
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
            <v-col cols="12" md="9" class="pa-1">
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg">
                <v-card-title class="base6--text">Datos Generales de la Adjudicación</v-card-title>
                <v-card-text class="px-0">
                  <v-row align="center" justify="start">
                    <custom-autocomplete
                      cols="8"
                      v-model="adjudicacionDirecta.idContratista"
                      label="Contratista"
                      :items="contratistas"
                      item-text="nombreRazonSocial"
                      item-value="id"
                      clearable
                      :rules="[mixReglas.requerido]">
                    </custom-autocomplete>
                    <v-col cols="1" class="pl-0">
                      <registrar-nuevo-contratista onlyIcon />
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="start">
                    <custom-date-picker
                      cols="12"
                      md="4"
                      v-model="adjudicacionDirecta.fecha"
                      label="Fecha Adjudicacion"
                      :rules="[mixReglas.requerido]">
                    </custom-date-picker>
                    <custom-text-field
                      cols="12"
                      md="4"
                      v-model="adjudicacionDirecta.numeroContrato"
                      label="Número de Contrato"
                      :rules="[mixReglas.requerido]">
                    </custom-text-field>
                    <custom-text-field
                      cols="12"
                      md="4"
                      v-model="adjudicacionDirecta.numeroDictamen"
                      label="Número de Dictamen"
                      :rules="[mixReglas.requerido]">
                    </custom-text-field>
                    <custom-text-area
                      cols="12"
                      v-model="adjudicacionDirecta.meta"
                      label="Meta"
                      rows="3"
                      :rules="[mixReglas.requerido]">
                    </custom-text-area>
                  </v-row>
                  <v-row align="center" justify="center">
                    <custom-text-field
                      cols="12"
                      md="3"
                      class="py-1"
                      v-model.number="adjudicacionDirecta.porcentajeAnticipo"
                      label="% Anticipo"
                      suffix="%"
                      type="number">
                    </custom-text-field>
                    <custom-date-picker
                      cols="12"
                      md="4"
                      lg="3"
                      v-model="adjudicacionDirecta.fechaInicio"
                      label="Fecha Inicio"
                      :rules="[mixReglas.requerido]">
                    </custom-date-picker>
                    <custom-date-picker
                      cols="12"
                      md="4"
                      lg="3"
                      v-model="adjudicacionDirecta.fechaTermino"
                      label="Fecha Termino"
                      :rules="[mixReglas.requerido]">
                    </custom-date-picker>
                    <custom-text-field
                      cols="12"
                      md="3"
                      class="py-1"
                      readonly
                      v-model.number="adjudicacionDirecta.plazo"
                      label="Plazo"
                      suffix="días"
                      type="number">
                    </custom-text-field>
                    <v-col
                      cols="12">
                      <v-divider
                        class="mb-4">
                      </v-divider>
                      <obras-picker
                        v-model="obrasSelected">
                      </obras-picker>
                    </v-col>
                  </v-row>
                  <v-card class="grey" flat>
                    <v-list
                      two-line
                      dense>
                      <template
                        v-for="obra in obrasSelected">
                        <v-list-item
                          :key="`obra-${obra.id}`">
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ obra.clave }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ obra.meta }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <custom-text-field
                              cols="12"
                              class="pa-0"
                              v-model.number="obra.importe"
                              label="Importe"
                              type="number"
                              prefix="$"
                              :rules="[mixReglas.requerido]"
                              @keyup="sumarImportesObras">
                            </custom-text-field>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" class="pa-1">
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg">
                <v-card-title class="base6--text">Monto de la Adjudicación</v-card-title>
                <v-card-text>
                  <v-row no-gutters>
                    <custom-text-field
                      cols="12"
                      class="pb-1"
                      v-model.number="adjudicacionDirecta.importe"
                      label="Importe"
                      type="number"
                      prefix="$"
                      :rules="[mixReglas.requerido]"
                      @keyup="calcularTotal">
                    </custom-text-field>
                    <custom-text-field
                      cols="12"
                      class="py-1"
                      v-model.number="adjudicacionDirecta.porcentajeIva"
                      label="% IVA"
                      suffix="%"
                      type="number"
                      :rules="[mixReglas.requerido]"
                      @keyup="calcularTotal">
                    </custom-text-field>
                    <custom-text-field
                      cols="12"
                      class="py-1"
                      v-model="adjudicacionDirecta.iva"
                      label="Importe IVA"
                      prefix="$"
                      type="number"
                      readonly
                      disabled>
                    </custom-text-field>
                    <custom-text-field
                      cols="12"
                      class="pt-1"
                      v-model="adjudicacionDirecta.total"
                      label="Total"
                      prefix="$"
                      readonly
                      disabled>
                    </custom-text-field>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixAgregarAdjudicacionDirecta"
              :disabled="!formularioValido || enviandoFormulario"
              tipo="formAceptar"
              label="Guardar">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import RegistrarNuevoContratista from '@/components/administracion/configuracion/catalogos/contratistas/Nuevo.vue';
import mixAdjudicaciones from './mixAdjudicaciones';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import ObrasPicker from '@/components/ObrasPicker.vue';
// import CustomSelect from '@/components/inputs/Select.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';

export default {
  name: 'NuevaAdjudicacion',
  mixins: [mixAdjudicaciones],
  components: {
    RegistrarNuevoContratista,
    CustomTextField,
    CustomButton,
    CustomAutocomplete,
    CustomTextArea,
    // CustomSelect,
    CustomDatePicker,
    ObrasPicker,
  },
  props: {
    onlyIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarDialogo: false,
      formularioValido: false,
      enviandoFormulario: false,
      adjudicacionDirecta: {
        idContratista: null,
        numeroContrato: null,
        meta: null,
        numeroDictamen: '',
        fecha: new Date().toISOString().substr(0, 10),
        importe: null,
        porcentajeIva: 16,
        iva: null,
        total: null,
        porcentajeAnticipo: 0,
        fechaInicio: new Date().toISOString().substr(0, 10),
        fechaTermino: new Date().toISOString().substr(0, 10),
        plazo: 1,
        obras: [],
      },
      obrasSelected: [],
    };
  },
  methods: {
    sumarImportesObras() {
      this.adjudicacionDirecta.importe = this.$ObjSumar(this.obrasSelected, 'importe');
    },
    limpiarFormulario() {
      this.$refs.agregarNuevaAdjudicacion.reset();
      this.adjudicacionDirecta.plazo = 0;
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
      this.mostrarDialogo = false;
    },
    setPlazo() {
      const { fechaInicio, fechaTermino } = this.adjudicacionDirecta;
      if (!fechaInicio || !fechaTermino) return;
      const a = this.$moment(fechaInicio);
      const b = this.$moment(fechaTermino);
      this.adjudicacionDirecta.plazo = (Number(b.diff(a, 'days')) + 1);
    },
    calcularTotal() {
      if (this.adjudicacionDirecta.importe === 0
      || this.adjudicacionDirecta.porcentajeIva === 0) return;
      const importe = Number(this.adjudicacionDirecta.importe);
      const porcentajeIVA = Number(this.adjudicacionDirecta.porcentajeIva);
      const importeIVA = this.$numberRound(parseFloat((importe * (porcentajeIVA / 100))));
      const total = this.$numberRound(parseFloat((importe + importeIVA)));

      this.adjudicacionDirecta.iva = importeIVA;
      this.adjudicacionDirecta.total = total;
      this.adjudicacionDirecta.importe = importe;
      this.adjudicacionDirecta.porcentajeIva = porcentajeIVA;
    },
  },
  computed: {
    fechaInicio() {
      return this.adjudicacionDirecta.fechaInicio;
    },
    fechaTermino() {
      return this.adjudicacionDirecta.fechaTermino;
    },
  },
  watch: {
    fechaInicio() {
      this.setPlazo();
    },
    fechaTermino() {
      this.setPlazo();
    },
    'adjudicacionDirecta.importe': {
      handler() {
        this.calcularTotal();
      },
    },
  },
};
</script>

<style>

</style>
